import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Autocomplete, Grid, TextField } from '@mui/material';

import FormInputLabel from './FormInputLabel';

export default function FormSearhcAndSelectInput({
    label,
    name,
    onChange,
    required = false,
    subText = '',
    options,
    optionKey,
    optionValue,
    labelSize = 6,
    inputSize = 6,
    noLabel = false,
    disabled = false,
    value = '',
    placeholder = 'Select or enter an option',
    style,
    disabledClassName,
    disabledInputColor = '#6B7280',
    renderOption,
}) {
    return (
        <>
            {!noLabel && <FormInputLabel labelSize={labelSize} label={label} subText={subText} required={required} />}

            <Grid
                item
                xs={inputSize}
                sx={{
                    marginBottom: style?.marginBottom ? style?.marginBottom : '16px',
                }}
            >
                <Autocomplete
                    name={name}
                    options={options ?? []}
                    value={value}
                    onChange={(e, newValue) => {
                        if (disabled) return;
                        // Call onChange when a value is selected from dropdown
                        onChange(e, newValue);
                    }}
                    onInputChange={(e, newInputValue) => {
                        if (disabled) return;
                        // Call onChange for ALL input changes (typing and selection) so the parent can track changes
                        onChange(e, newInputValue);
                    }}
                    disabled={disabled}
                    required={required}
                    fullWidth
                    disableClearable
                    freeSolo
                    popupIcon={<KeyboardArrowDownIcon />}
                    slots={{
                        openPopupIcon: KeyboardArrowUpIcon
                    }}
                    renderInput={(params) => (
                        <TextField
                            required={required}
                            {...params}
                            disabled={disabled}
                            InputLabelProps={{ shrink: false }}
                            placeholder={placeholder}
                            className={disabled ? 'form-search-select-disabled' : undefined}
                            inputProps={{
                                ...params.inputProps,
                                style: {
                                    ...(params.inputProps?.style || {}),
                                    cursor: disabled ? 'not-allowed' : params.inputProps?.style?.cursor,
                                    color: disabled ? disabledInputColor : params.inputProps?.style?.color,
                                    WebkitTextFillColor: disabled ? disabledInputColor : params.inputProps?.style?.WebkitTextFillColor,
                                },
                                readOnly: disabled ? true : params.inputProps?.readOnly,
                            }}
                        />
                    )}
                    sx={{
                        '& .MuiOutlinedInput-input::placeholder': {
                            color: '#4A4A4A',
                            opacity: 1,
                        },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            transition: disabled ? 'none' : 'all 0.3s ease',
                            backgroundColor: '#f5f1ed',
                            border: '1px solid #cbc1b7',
                            ...(disabled && {
                                opacity: 0.6,
                                color: '#6B7280',
                                cursor: 'not-allowed',
                                backgroundColor: '#f5f1ed',
                                borderColor: '#cbc1b7',
                                pointerEvents: 'none',
                                '& .MuiAutocomplete-input': {
                                    color: disabledInputColor,
                                    WebkitTextFillColor: disabledInputColor,
                                    cursor: 'not-allowed',
                                },
                                '& .MuiAutocomplete-endAdornment': {
                                    display: 'none',
                                },
                            }),
                            '&:hover': {
                                borderColor: disabled ? '#cbc1b7' : '#ff5f39',
                                backgroundColor: disabled ? '#f5f1ed' : 'white',
                                boxShadow: disabled ? 'none' : undefined,
                            },
                            '&.Mui-focused': {
                                borderColor: disabled ? '#cbc1b7' : '#ff5f39',
                                backgroundColor: disabled ? '#f5f1ed' : 'white',
                                boxShadow: disabled ? 'none' : '0 0 0 2px rgba(255, 95, 57, 0.1)',
                            },
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                        },
                        '& .MuiInputBase-input': {
                            color: disabled ? disabledInputColor : '#000000',
                            WebkitTextFillColor: disabled ? disabledInputColor : undefined,
                            padding: '0px !important',
                        },
                        '& .MuiAutocomplete-input': {
                            padding: '0px !important',
                            color: disabled ? disabledInputColor : undefined,
                            WebkitTextFillColor: disabled ? disabledInputColor : undefined,
                        },
                        '& .MuiAutocomplete-inputRoot': {
                            padding: '9.5px 14px 9.5px 20px !important',
                            cursor: disabled ? 'not-allowed' : undefined,
                            backgroundColor: disabled ? '#f5f1ed' : undefined,
                            pointerEvents: disabled ? 'none' : undefined,
                        },
                        '& .MuiAutocomplete-endAdornment': {
                            display: disabled ? 'none' : undefined,
                        },
                    }}
                    renderOption={renderOption}
                    PaperProps={{
                        sx: {
                            backgroundColor: '#f3ede8 !important',
                            '& .MuiAutocomplete-option': {
                                backgroundColor: '#f3ede8 !important',
                                '&:hover': {
                                    backgroundColor: '#e0e0e0 !important',
                                },
                            },
                        },
                    }}
                />
            </Grid>
        </>
    );
}
